export default "__VITE_PUBLIC_ASSET__3bf82ecf__"